import { useState, useCallback } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../services/network'
import { useSnackBar } from '../providers/snack_bar_provider'

export const useBusinessIdeaGenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isGenerating, setIsGenerating] = useState(false)

  const generateBusinessIdea = useCallback(async (
    aiInstruction: string | null,
    onSuccess?: () => void
  ) => {
    setIsGenerating(true)

    try {
      const response = await apiClient.business.generateCreate({
        aiInstruction: aiInstruction,
      })

      if (response) {
        showSnackBar(['事業アイデアの生成が完了しました'], 'success', null) // 自動で消えない
        onSuccess?.()
      }
    } catch (e) {
      console.error('事業アイデアの生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsGenerating(false)
    }
  }, [apiClient, showSnackBar])

  return {
    isGenerating,
    generateBusinessIdea,
  }
}
